<template>
  <div>
    <ServicesHero
      v-if="!authenticated"
      :initial-fields="initialFields"
      :title="titleHero"
      :image="imageHero"
      :file="brochureFileInfo"
      download-text="Brochure"
    >
      <template v-if="hasBookableDemo" #extra-ctas>
        <ButtonBookADemo />
      </template>
    </ServicesHero>

    <div
      class="mx-auto flex w-full max-w-content-container flex-col justify-center gap-y-7 px-small pb-20 pt-8 md:items-start xl:pb-36 xl:pl-16 xl:pr-0 xl:pt-10"
    >
      <Breadcrumb v-if="authenticated" :menu="breadcrumbStore.items" />
      <SectionTitle :title="titlePage" :icon="icon" />

      <section class="w-full lg:rounded-xl lg:bg-white lg:p-6 lg:shadow-pm">
        <div
          class="flex flex-col gap-5 xl:flex-row xl:items-center xl:justify-between"
        >
          <div class="h-10">
            <client-only>
              <TheTabsBySlug
                :tabs="tabs"
                @active-tab-changed="$emit('active-tab-changed', $event)"
              />
            </client-only>
          </div>
          <slot v-if="!authenticated" name="methodology" />
        </div>
        <slot />
      </section>
    </div>
  </div>
</template>

<script setup lang="ts">
/** components */
import ServicesHero from '~/components/shared/services/Hero.vue'
import SectionTitle from '~/components/price-assessments/SectionTitle.vue'
import TheTabsBySlug from '~/components/common/TheTabsBySlug.vue'
import Breadcrumb from '~/components/shared/navigation/Breadcrumb.vue'
import ButtonBookADemo from '~/components/shared/common/ButtonBookADemo.vue'

/** stores */
import useAuthStore from '~/stores/auth'
import { useBreadcrumbStore } from '~/stores/breadcrumb'

/** types */
import type { TFileDownloadInfo } from '~/src/types/download'
import { storeToRefs } from 'pinia'

/** props */
defineProps<{
  initialFields: string[]
  titleHero: string
  imageHero: string
  brochureFileInfo?: TFileDownloadInfo
  titlePage: string
  icon: string
  tabs: any[]
  hasBookableDemo?: boolean
}>()

/** events */
defineEmits<{
  'active-tab-changed': [tab: string]
}>()

/** app */
const breadcrumbStore = useBreadcrumbStore()
const authStore = useAuthStore()
const { authenticated } = storeToRefs(authStore)
</script>
